import type { IconType } from 'react-icons'
import {
  FiBookOpen,
  FiCamera,
  FiCloudSnow,
  FiCoffee,
  FiCompass,
  FiFilm,
  FiGlobe,
  FiGrid,
  FiHeart,
  FiHome,
  FiMapPin,
  FiMoon,
  FiShoppingBag,
  FiSun,
  FiTriangle,
  FiUmbrella,
  FiUsers,
  FiFeather
} from 'react-icons/fi'
import { FaPaw, FaRegGem } from 'react-icons/fa'

import { formatInterest } from 'travelInterests'

const ICONS: Record<string, IconType> = {
  cidade_historica: FiMapPin,
  cidade_moderna: FiGrid,
  montanha: FiTriangle,
  praia: FiUmbrella,
  familiar: FiUsers,
  pet_friendly: FaPaw,
  cultural: FiBookOpen,
  gastronomico: FiCoffee,
  aventura: FiCompass,
  romantico: FiHeart,
  vida_noturna: FiMoon,
  ecologico: FiFeather,
  luxuoso: FaRegGem,
  religioso: FiHome,
  compras: FiShoppingBag,
  fotografia: FiCamera,
  clima_frio: FiCloudSnow,
  clima_quente: FiSun,
  cinema: FiFilm,
  natureza: FiGlobe
}

type Props = {
  value: string
  title?: string
}

const TravelInterestIcon = ({ value, title }: Props) => {
  const Icon = ICONS[value] || FiMapPin
  const label = title || formatInterest(value)

  return <Icon role="img" aria-label={label} title={label} />
}

export default TravelInterestIcon
